import styles from '../../styles/contato.module.css';

export function HeaderContactForm() {
  return (
    <div className="text-center mb-4">
      <h2 className={styles.title}>Estamos aqui para ajudar</h2>
      <p className="text-muted">
        Nosso canal está aberto para sugestões, relatos e parcerias. Vamos
        construir juntos uma cidade mais segura.
      </p>
    </div>
  );
}
